const doc = [({"da":({"js":({"admin":({"survey_judges":({"row":({"select_contact":"Vælg kontakt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;